import React, { FC, useState } from 'react';
import COTable from 'shared/components/COTable';
import { useLocationsDataContext } from 'context/LocationsDataContext';
import { UserDetailsTableProps } from 'enums/AccountsListEnums';
import { LocationModel } from 'models/CompanySetup/location.model';
import useRedirect from 'shared/utils/useRedirect';
import { defaultYearTab } from 'constants/constants';
import LocationTableColumns from './locationColumns';
import { useParentOrganizationContext } from 'context/ParentOrganisationContext';
import { useSearchParams } from 'react-router-dom';
import { SortingTypesEnums } from 'enums/sortingTypes.enum';
interface LocationTableProps {
  tableLoading?: boolean;
}
const LocationTable: FC<LocationTableProps> = ({ tableLoading }) => {
  const { locationTableData } = useLocationsDataContext();
  const [sortOrder, setSortOrder] = useState<{
    field: string;
    order: SortingTypesEnums.DESCEND | SortingTypesEnums.ASCEND | undefined;
  }>({
    field: '',
    order: undefined,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const { organizationData } = useParentOrganizationContext();
  const { redirectToActivityDataEntry } = useRedirect();
  const handleOnRowEvents = (record: LocationModel) =>
    redirectToActivityDataEntry(String(record?.id), {
      activeTab: defaultYearTab,
    });

  const columns = LocationTableColumns({
    sortOrder,
    setSortOrder,
    searchParams,
    setSearchParams,
  });

  return (
    <>
      {organizationData?.company?.hasLocations ? (
        <COTable
          loading={tableLoading}
          columns={columns}
          data={locationTableData?.data}
          handleRowClick={handleOnRowEvents}
          headingDelete={UserDetailsTableProps.DELETE_MODAL_HEADING}
          subheadingDelete={UserDetailsTableProps.DELTE_MODAL_SUBHEADING}
        />
      ) : null}
    </>
  );
};

export default LocationTable;
